/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionSchema } from '../collection-schema';

export const listCollectionChildrenResponseDataSchema = z.array(collectionSchema);

export type IListCollectionChildrenResponseData = z.infer<
  typeof listCollectionChildrenResponseDataSchema
>;

export const listCollectionChildrenResponseSchema = createApiResponseSchema(
  listCollectionChildrenResponseDataSchema,
) as z.ZodSchema<IAPI<IListCollectionChildrenResponseData>>;

export type IListCollectionChildrenResponse = IAPI<IListCollectionChildrenResponseData>;
